import _classCallCheck from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var s, e;
(e = s || (s = {}))[e.VERBOSE = 0] = "VERBOSE", e[e.DEBUG = 1] = "DEBUG", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.NONE = 5] = "NONE";
var o = /*#__PURE__*/function () {
  function o() {
    _classCallCheck(this, o);
  }
  _createClass(o, null, [{
    key: "v",
    value: function v(e) {
      for (var _len = arguments.length, o = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        o[_key - 1] = arguments[_key];
      }
      this.log.apply(this, [s.VERBOSE, e].concat(o));
    }
  }, {
    key: "d",
    value: function d(e) {
      for (var _len2 = arguments.length, o = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        o[_key2 - 1] = arguments[_key2];
      }
      this.log.apply(this, [s.DEBUG, e].concat(o));
    }
  }, {
    key: "i",
    value: function i(e) {
      for (var _len3 = arguments.length, o = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        o[_key3 - 1] = arguments[_key3];
      }
      this.log.apply(this, [s.INFO, e].concat(o));
    }
  }, {
    key: "w",
    value: function w(e) {
      for (var _len4 = arguments.length, o = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        o[_key4 - 1] = arguments[_key4];
      }
      this.log.apply(this, [s.WARN, e].concat(o));
    }
  }, {
    key: "e",
    value: function e(_e) {
      for (var _len5 = arguments.length, o = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        o[_key5 - 1] = arguments[_key5];
      }
      this.log.apply(this, [s.ERROR, _e].concat(o));
    }
  }, {
    key: "log",
    value: function log(e, o) {
      var _console, _console2, _console3, _console4, _console5;
      for (var _len6 = arguments.length, t = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        t[_key6 - 2] = arguments[_key6];
      }
      if (!(this.level.valueOf() > e.valueOf())) switch (e) {
        case s.VERBOSE:
          (_console = console).log.apply(_console, ["HMSui-components: ", o].concat(t));
          break;
        case s.DEBUG:
          (_console2 = console).debug.apply(_console2, ["HMSui-components: ", o].concat(t));
          break;
        case s.INFO:
          (_console3 = console).info.apply(_console3, ["HMSui-components: ", o].concat(t));
          break;
        case s.WARN:
          (_console4 = console).warn.apply(_console4, ["HMSui-components: ", o].concat(t));
          break;
        case s.ERROR:
          (_console5 = console).error.apply(_console5, ["HMSui-components: ", o].concat(t));
      }
    }
  }]);
  return o;
}();
o.level = s.VERBOSE;
export { s as HMSLogLevel, o as default };